// Auto-generated skeleton for Ticket

import { Team } from "./Team";
import { TicketType } from "./TicketType";
import { Record } from "./Record";

export const Ticket: Api.Ticket = {
  id: 0,
  hp_id: null,
  type_id: 0,
  active: 0,
  released: '',
  deadline: null,
  team_id_released: 0,
  team_released: Team,
  done: 0,
  created_hp: '',
  comment: null,
  ticket_type: TicketType,
  records: [Record],
  created: null,
  updated: null,
};

